@import '@client/theme/theme.less';

.info {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  width: 300px;

  li {
    display: flex;
    justify-content: space-between;
  }

  :global(.ant-card-head) {
    background-color: @color-bg-muted;
  }
}

.infoTitle {
  display: flex;
  justify-content: space-between;
}
